/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Profile() {
  return (
    <>
      <section className="section pb-5">
        <div className="container">
          <div className="row mb-5 align-items-end">
            <div className="col-md-6" data-aos="fade-up">
              <h2>About Me</h2>
              <p className="mb-0">
                Hi, I'm Waleed from Islamabad, Pakistan. I currently live in Istanbul, Turkey. I hold a bachelors degree in New Media. I enjoy doing graphic designing,
                recording and editing videos along with taking photos. I also like to collaborate with other professionals in variety of projects.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 ml-auto order-2" data-aos="fade-up">
              <h3 className="h3 mb-4">Skills</h3>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>WordPress</strong>
                    <span className="ml-12">80%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>Photoshop</strong>
                    <span className="ml-12">80%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>IIIustrator</strong>
                    <span className="ml-12">90%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>Premier pro</strong>
                    <span className="ml-12">90%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>Figma</strong>
                    <span className="ml-12">70%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "70%" }} aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>Copywriting</strong>
                    <span className="ml-12">90%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex mb-1">
                    <strong>Adobe XD</strong>
                    <span className="ml-12">70%</span>
                  </div>
                  <div className="progress custom-progress">
                    <div className="progress-bar" role="progressbar" style={{ width: "70%" }} aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-md-7 mb-5 mb-md-0" data-aos="fade-up">
              <p>
                <img src="assets/img/person_1_sq.jpg" alt="Image" className="img-fluid" />
              </p>
              <p>
                <a href="https://www.dropbox.com/s/039xzyrfv05gcxv/CV_Waleed_Shahab.pdf?dl=1" target="_blank" className="readmore" rel="noreferrer">
                  Download my CV
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
